var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/react/BlockContextMenuPlugin.tsx
import { createTPlatePlugin } from "@udecode/plate-common/react";
var BlockContextMenuPlugin = createTPlatePlugin({
  key: "blockContextMenu",
  options: {
    action: { group: null, value: null },
    anchorRect: { x: 0, y: 0 },
    openEditorId: null,
    store: null
  }
}).extendApi(({ getOptions, setOptions }) => ({
  hide: () => {
    setOptions({
      anchorRect: { x: 0, y: 0 },
      openEditorId: null
    });
  },
  reset: () => {
    setOptions({ anchorRect: { x: 0, y: 0 } });
  },
  show: (editorId, event) => {
    const { store } = getOptions();
    setOptions({
      anchorRect: { x: event.clientX, y: event.clientY },
      openEditorId: editorId
    });
    if (store) {
      store.show();
      store.setAutoFocusOnShow(true);
      store.setInitialFocus("first");
    }
  }
})).extendOptions(({ getOptions }) => ({
  isOpen: (editorId) => getOptions().openEditorId === editorId
})).extend(({ api }) => ({
  handlers: {
    onMouseDown: ({ editor, event, getOption }) => {
      if (event.button === 0 && getOption("isOpen", editor.id)) {
        event.preventDefault();
        api.blockContextMenu.hide();
      }
      if (event.button === 2) event.preventDefault();
    }
  }
}));

// src/react/BlockSelectionPlugin.tsx
import {
  getNodeEntries
} from "@udecode/plate-common";
import { createTPlatePlugin as createTPlatePlugin2 } from "@udecode/plate-common/react";

// src/lib/extractSelectableIds.ts
var extractSelectableIds = (els) => {
  return els.map((v) => v.dataset.key);
};

// src/lib/getAboveDomNode.ts
var getSelectedDomNode = (id) => {
  return document.querySelector(`.slate-selectable[data-key="${id}"]`);
};
var getAllSelectableDomNode = () => {
  return document.querySelectorAll(`.slate-selectable`);
};

// src/react/BlockSelectionAfterEditable.tsx
import React2 from "react";
import ReactDOM from "react-dom";
import {
  findNode,
  getEndPoint as getEndPoint2,
  getNextNode,
  getPreviousNode,
  isHotkey,
  removeNodes
} from "@udecode/plate-common";
import {
  focusEditor as focusEditor2,
  isEditorReadOnly,
  useEditorPlugin as useEditorPlugin2,
  useEditorRef
} from "@udecode/plate-common/react";

// src/react/useSelectionArea.ts
import React from "react";
import { deselectEditor, useEditorPlugin } from "@udecode/plate-common/react";

// src/internal/EventEmitter.ts
var EventTarget = class {
  constructor() {
    this._listeners = /* @__PURE__ */ new Map();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.emit = this.dispatchEvent;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.off = this.removeEventListener;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.on = this.addEventListener;
  }
  addEventListener(event, cb) {
    var _a;
    const set = (_a = this._listeners.get(event)) != null ? _a : /* @__PURE__ */ new Set();
    this._listeners.set(event, set);
    set.add(cb);
    return this;
  }
  // Let's also support on, off and emit like node
  dispatchEvent(event, ...data) {
    var _a;
    let ok = true;
    for (const cb of (_a = this._listeners.get(event)) != null ? _a : []) {
      ok = cb(...data) !== false && ok;
    }
    return ok;
  }
  removeEventListener(event, cb) {
    var _a;
    (_a = this._listeners.get(event)) == null ? void 0 : _a.delete(cb);
    return this;
  }
  unbindAllListeners() {
    this._listeners.clear();
  }
};

// src/internal/utils/css.ts
var unitify = (val, unit = "px") => {
  return typeof val === "number" ? val + unit : val;
};
function css({ style }, attr, val) {
  if (typeof attr === "object") {
    for (const [key, value] of Object.entries(attr)) {
      value !== void 0 && (style[key] = unitify(value));
    }
  } else if (val !== void 0) {
    style[attr] = unitify(val);
  }
}

// src/internal/utils/events.ts
var eventListener = (method) => (items, events, fn, options = {}) => {
  if (items instanceof HTMLCollection || items instanceof NodeList) {
    items = Array.from(items);
  } else if (!Array.isArray(items)) {
    items = [items];
  }
  if (!Array.isArray(events)) {
    events = [events];
  }
  for (const el of items) {
    if (el) {
      for (const ev of events) {
        el[method](ev, fn, __spreadValues({ capture: false }, options));
      }
    }
  }
  return [items, events, fn, options];
};
var on = eventListener("addEventListener");
var off = eventListener("removeEventListener");
var simplifyEvent = (evt) => {
  var _a, _b;
  const { clientX, clientY, target } = (_b = (_a = evt.touches) == null ? void 0 : _a[0]) != null ? _b : evt;
  return { target, x: clientX, y: clientY };
};

// src/internal/utils/intersects.ts
function intersectsScroll(a, b, mode = "touch", container) {
  const containerRect = container.getBoundingClientRect();
  const scrollLeft = container.scrollLeft;
  const scrollTop = container.scrollTop;
  return a.right >= b.left - containerRect.left && a.left + containerRect.left <= b.right + scrollLeft && // 94 is container to top
  a.bottom - scrollTop >= b.top - containerRect.top && a.top <= b.bottom - containerRect.top + scrollTop;
}

// src/internal/utils/selectAll.ts
function selectAll(selector, doc = document) {
  const list = Array.isArray(selector) ? selector : [selector];
  let nodes = [];
  for (let i = 0, l = list.length; i < l; i++) {
    const item = list[i];
    if (typeof item === "string") {
      nodes = nodes.concat(Array.from(doc.querySelectorAll(item)));
    } else if (item instanceof Element) {
      nodes.push(item);
    }
  }
  return nodes;
}

// src/internal/utils/constants.ts
var isTouchDevice = () => matchMedia("(hover: none), (pointer: coarse)").matches;
var isSafariBrowser = () => "safari" in window;

// src/internal/utils/frames.ts
var frames = (fn) => {
  let previousArgs;
  let frameId = -1;
  let lock = false;
  return {
    cancel() {
      cancelAnimationFrame(frameId);
      lock = false;
    },
    next(...args) {
      previousArgs = args;
      if (!lock) {
        lock = true;
        frameId = requestAnimationFrame(() => {
          fn(...previousArgs);
          lock = false;
        });
      }
    }
  };
};

// src/internal/utils/shouldTrigger.ts
function shouldTrigger(event, triggers) {
  for (const trigger of triggers) {
    if (typeof trigger === "number") {
      return event.button === trigger;
    }
    if (typeof trigger === "object") {
      const reqButtonIsPressed = trigger.button === event.button;
      const allReqModifiersArePressed = trigger.modifiers.every((modifier) => {
        switch (modifier) {
          case "alt": {
            return event.altKey;
          }
          case "ctrl": {
            return event.ctrlKey || event.metaKey;
          }
          case "shift": {
            return event.shiftKey;
          }
        }
      });
      return reqButtonIsPressed && allReqModifiersArePressed;
    }
  }
  return false;
}

// src/internal/SelectionArea.ts
var { abs, ceil, max, min } = Math;
var SelectionArea = class extends EventTarget {
  constructor(opt) {
    var _a, _b, _c, _d, _e;
    super();
    this._areaClientLocation = { x1: 0, x2: 0, y1: 0, y2: 0 };
    // Dynamically constructed area rect
    this._areaLocation = { x1: 0, x2: 0, y1: 0, y2: 0 };
    // Caches the position of the selection-area
    this._areaRect = new DOMRect();
    this._initScrollDelta = { x: 0, y: 0 };
    // Is getting set on movement.
    this._scrollAvailable = true;
    // The scroll distance of scrollElement (body or html) relative to the initial scroll position
    this._scrollDelta = { x: 0, y: 0 };
    this._scrollSpeed = { x: 0, y: 0 };
    // If a single click is being performed.
    this._scrollingActive = false;
    this._selectables = [];
    // Selection store
    this._selection = {
      changed: {
        added: [],
        // Added elements since last selection
        removed: []
        // Removed elements since last selection
      },
      selected: [],
      stored: [],
      touched: []
    };
    // It's a single-click until the user dragged the mouse.
    this._singleClick = true;
    this.wheelTimer = null;
    this.disable = this._bindStartEvents.bind(this, false);
    this.enable = this._bindStartEvents;
    this._options = __spreadProps(__spreadValues({
      boundaries: ["html"],
      container: "body",
      document: window.document,
      selectables: [],
      selectionAreaClass: "selection-area",
      startAreas: ["html"]
    }, opt), {
      behaviour: __spreadProps(__spreadValues({
        // TODO: not implemented
        intersect: "touch",
        overlap: "invert",
        triggers: [0]
      }, opt.behaviour), {
        scrolling: __spreadProps(__spreadValues({
          manualSpeed: 750,
          speedDivider: 10
        }, (_a = opt.behaviour) == null ? void 0 : _a.scrolling), {
          startScrollMargins: __spreadValues({
            x: 20,
            y: 20
          }, (_c = (_b = opt.behaviour) == null ? void 0 : _b.scrolling) == null ? void 0 : _c.startScrollMargins)
        }),
        startThreshold: ((_d = opt.behaviour) == null ? void 0 : _d.startThreshold) ? typeof opt.behaviour.startThreshold === "number" ? opt.behaviour.startThreshold : __spreadValues({ x: 20, y: 20 }, opt.behaviour.startThreshold) : { x: 20, y: 20 }
      }),
      features: __spreadProps(__spreadValues({
        range: true,
        touch: true
      }, opt.features), {
        singleTap: __spreadValues({
          allow: true,
          intersect: "native"
        }, (_e = opt.features) == null ? void 0 : _e.singleTap)
      })
    });
    for (const key of Object.getOwnPropertyNames(Object.getPrototypeOf(this))) {
      if (typeof this[key] === "function") {
        this[key] = this[key].bind(this);
      }
    }
    const { document: document2, selectionAreaClass } = this._options;
    this._area = document2.createElement("div");
    this._area.classList.add(selectionAreaClass);
    css(this._area, {
      left: 0,
      position: "absolute",
      top: 0,
      willChange: "top, left, bottom, right, width, height"
    });
    this._frame = frames((evt) => {
      this._recalculateSelectionAreaRect();
      this._updateElementSelection();
      this._emitEvent("move", evt);
      this._redrawSelectionArea();
    });
    this.enable();
  }
  _bindStartEvents(activate = true) {
    const { document: document2, features } = this._options;
    const fn = activate ? on : off;
    fn(document2, "mousedown", this._onTapStart);
    features.touch && fn(document2, "touchstart", this._onTapStart, {
      passive: false
    });
  }
  _delayedTapMove(evt) {
    const {
      behaviour: { startThreshold },
      document: document2
    } = this._options;
    const { x1, y1 } = this._areaLocation;
    const { x1: clientX, y1: clientY } = this._areaClientLocation;
    const { x, y } = simplifyEvent(evt);
    if (
      // Single number for both coordinates
      typeof startThreshold === "number" && abs(x + y - (clientX + clientY)) >= startThreshold || // Different x and y threshold
      typeof startThreshold === "object" && abs(x - x1) >= startThreshold.x || abs(y - y1) >= startThreshold.y
    ) {
      off(document2, ["mousemove", "touchmove"], this._delayedTapMove, {
        passive: false
      });
      if (this._emitEvent("beforedrag", evt) === false) {
        off(document2, ["mouseup", "touchcancel", "touchend"], this._onTapStop);
        return;
      }
      on(document2, ["mousemove", "touchmove"], this._onTapMove, {
        passive: false
      });
      css(this._area, "display", "block");
      this._container.append(this._area);
      this.resolveSelectables();
      this._singleClick = false;
      on(this._container, "wheel", this._manualScroll, { passive: true });
      this._setupSelectionArea();
      this._emitEvent("start", evt);
      this._onTapMove(evt);
    }
    this._handleMoveEvent(evt);
  }
  _emitEvent(name, evt) {
    return this.emit(name, {
      event: evt,
      selection: this,
      store: this._selection
    });
  }
  _handleMoveEvent(evt) {
    const { features } = this._options;
    if (features.touch && isTouchDevice() || this._scrollAvailable && isSafariBrowser()) {
      evt.preventDefault();
    }
  }
  _keepSelection() {
    const { _options, _selection } = this;
    const { changed, selected, stored, touched } = _selection;
    const addedElements = selected.filter((el) => !stored.includes(el));
    switch (_options.behaviour.overlap) {
      case "drop": {
        _selection.stored = [
          ...addedElements,
          ...stored.filter((el) => !touched.includes(el))
          // Elements not touched
        ];
        break;
      }
      case "invert": {
        _selection.stored = [
          ...addedElements,
          ...stored.filter((el) => !changed.removed.includes(el))
          // Elements not removed from selection
        ];
        break;
      }
      case "keep": {
        _selection.stored = [
          ...stored,
          ...selected.filter((el) => !stored.includes(el))
          // Newly added
        ];
        break;
      }
    }
  }
  _manualScroll(evt) {
    this.wheelTimer && clearTimeout(this.wheelTimer);
    const { x, y } = simplifyEvent(evt);
    this.wheelTimer = setTimeout(() => {
      this._areaClientLocation.x2 = x;
      this._areaClientLocation.y2 = y;
      const Ry = y - this._containerRect.top;
      const Rx = x - this._containerRect.left;
      this._areaLocation.x2 = Rx + this._container.scrollLeft;
      this._areaLocation.y2 = Ry + this._container.scrollTop;
      this._frame.next(null);
    }, 100);
  }
  _onScroll(evt) {
    const { document: document2 } = this._options;
    this.wheelTimer && clearTimeout(this.wheelTimer);
    const { x, y } = simplifyEvent(evt);
    this.wheelTimer = setTimeout(() => {
      this._areaClientLocation.x2 = x;
      this._areaClientLocation.y2 = y;
      const deltaY = y - this._containerRect.top + this._container.scrollTop + document2.scrollingElement.scrollTop - this._initScrollDelta.y;
      const deltaX = x - this._containerRect.left + this._container.scrollLeft + document2.scrollingElement.scrollLeft;
      this._scrollDelta.y = document2.scrollingElement.scrollTop - this._initScrollDelta.y;
      this._scrollDelta.x = document2.scrollingElement.scrollLeft - this._initScrollDelta.x;
      this._areaLocation.y2 = deltaY;
      this._areaLocation.x2 = deltaX;
      this._frame.next(null);
    }, 100);
  }
  _onSingleTap(evt) {
    const {
      range,
      singleTap: { intersect }
    } = this._options.features;
    const e = simplifyEvent(evt);
    let target;
    if (intersect === "native") {
      target = e.target;
    } else if (intersect === "touch") {
      this.resolveSelectables();
      const { x, y } = e;
      target = this._selectables.find((v) => {
        const { bottom, left, right, top } = v.getBoundingClientRect();
        return x < right && x > left && y < bottom && y > top;
      });
    }
    if (!target) {
      return;
    }
    this.resolveSelectables();
    while (!this._selectables.includes(target)) {
      if (!target.parentElement) {
        return;
      }
      target = target.parentElement;
    }
    const { stored } = this._selection;
    this._emitEvent("start", evt);
    if (evt.shiftKey && range && this._latestElement) {
      const reference = this._latestElement;
      const [preceding, following] = reference.compareDocumentPosition(target) & 4 ? [target, reference] : [reference, target];
      const rangeItems = [
        ...this._selectables.filter(
          (el) => el.compareDocumentPosition(preceding) & 4 && el.compareDocumentPosition(following) & 2
        ),
        preceding,
        following
      ];
      this.select(rangeItems);
      this._latestElement = reference;
    } else if (stored.includes(target) && (stored.length === 1 || evt.ctrlKey || stored.every((v) => this._selection.stored.includes(v)))) {
      this.deselect(target);
    } else {
      this.select(target);
      this._latestElement = target;
    }
  }
  _onTapMove(evt) {
    const { x, y } = simplifyEvent(evt);
    const {
      _areaClientLocation,
      _areaLocation,
      _frame,
      _options,
      _scrollSpeed
    } = this;
    const { speedDivider } = _options.behaviour.scrolling;
    const Ry = y - this._containerRect.top;
    const Rx = x - this._containerRect.left;
    if (this._scrollAvailable && !this._scrollingActive && (_scrollSpeed.y || _scrollSpeed.x)) {
      this._scrollingActive = true;
      const scroll = () => {
        if (!_scrollSpeed.x && !_scrollSpeed.y) {
          this._scrollingActive = false;
          return;
        }
        if (_scrollSpeed.y) {
          this._container.scrollTop += ceil(_scrollSpeed.y / speedDivider);
          _areaLocation.y2 = Ry;
        }
        if (_scrollSpeed.x) {
          this._container.scrollLeft += ceil(_scrollSpeed.x / speedDivider);
          _areaLocation.x2 = Rx;
        }
        _frame.next(evt);
        requestAnimationFrame(scroll);
      };
      requestAnimationFrame(scroll);
    } else {
      _areaLocation.x2 = Rx + this._container.scrollLeft + this._scrollDelta.x;
      _areaLocation.y2 = Ry + this._container.scrollTop + this._scrollDelta.y;
      _areaClientLocation.x2 = x;
      _areaClientLocation.y2 = y;
      _frame.next(evt);
    }
    this._handleMoveEvent(evt);
  }
  _onTapStart(evt, silent = false) {
    var _a;
    const { container, document: document2 } = this._options;
    const { target, x, y } = simplifyEvent(evt);
    this._container = selectAll(container, document2)[0];
    if (this._container.contains(target) && target.dataset.plateSelectable !== "true")
      return;
    this._containerRect = this._container.getBoundingClientRect();
    const Rx = x - this._containerRect.left + this._container.scrollLeft;
    const Ry = y - this._containerRect.top + this._container.scrollTop;
    const { _options } = this;
    if (evt instanceof MouseEvent && !shouldTrigger(evt, _options.behaviour.triggers)) {
      return;
    }
    const startAreas = selectAll(_options.startAreas, _options.document);
    const resolvedBoundaries = selectAll(
      _options.boundaries,
      _options.document
    );
    const evtPath = evt.composedPath();
    if (!this._container || // eslint-disable-next-line unicorn/prefer-array-some
    !startAreas.find((el) => evtPath.includes(el)) || // eslint-disable-next-line unicorn/prefer-array-some
    !resolvedBoundaries.find((el) => evtPath.includes(el))) {
      return;
    }
    if (!silent && this._emitEvent("beforestart", evt) === false) {
      return;
    }
    this._areaLocation = { x1: Rx, x2: 0, y1: Ry, y2: 0 };
    this._areaClientLocation = { x1: x, x2: 0, y1: y, y2: 0 };
    const scrollElement = (_a = document2.scrollingElement) != null ? _a : document2.body;
    this._initScrollDelta = {
      x: scrollElement.scrollLeft,
      y: scrollElement.scrollTop
    };
    this._singleClick = true;
    this.clearSelection(false, true);
    on(document2, ["touchmove", "mousemove"], this._delayedTapMove, {
      passive: false
    });
    on(document2, ["mouseup", "touchcancel", "touchend"], this._onTapStop);
    on(document2, "wheel", this._onScroll, { passive: false });
  }
  _onTapStop(evt, silent) {
    var _a;
    const { document: document2, features } = this._options;
    const { _singleClick } = this;
    off(document2, ["mousemove", "touchmove"], this._delayedTapMove);
    off(document2, ["touchmove", "mousemove"], this._onTapMove);
    off(document2, ["mouseup", "touchcancel", "touchend"], this._onTapStop);
    off(document2, "wheel", this._onScroll);
    this._keepSelection();
    if (evt && _singleClick && features.singleTap.allow) {
      this._onSingleTap(evt);
    } else if (!_singleClick && !silent) {
      this._updateElementSelection();
      this._emitEvent("stop", evt);
    }
    this._scrollSpeed.x = 0;
    this._scrollSpeed.y = 0;
    this._scrollDelta.x = 0;
    this._scrollDelta.y = 0;
    off(this._container, "wheel", this._manualScroll, { passive: true });
    this._area.remove();
    (_a = this._frame) == null ? void 0 : _a.cancel();
    css(this._area, "display", "none");
  }
  _recalculateSelectionAreaRect() {
    const {
      _areaClientLocation,
      _areaLocation,
      _areaRect,
      _container,
      _containerRect,
      _scrollSpeed
    } = this;
    const {
      clientHeight,
      clientWidth,
      scrollHeight,
      scrollLeft,
      scrollTop,
      scrollWidth
    } = _container;
    const { x1, y1 } = _areaLocation;
    let { x2, y2 } = _areaLocation;
    const {
      behaviour: {
        scrolling: { startScrollMargins }
      }
    } = this._options;
    if (_areaClientLocation.x2 + this._scrollDelta.x < _containerRect.left + startScrollMargins.x) {
      _scrollSpeed.x = scrollLeft ? -abs(
        _containerRect.left - _areaClientLocation.x2 - this._scrollDelta.x
      ) : 0;
      x2 = max(x2, this._container.scrollLeft);
    } else if (_areaClientLocation.x2 + this._scrollDelta.x > _containerRect.right - startScrollMargins.x) {
      _scrollSpeed.x = scrollWidth - scrollLeft - clientWidth ? abs(
        _containerRect.left + this._container.clientWidth - _areaClientLocation.x2 - this._scrollDelta.x
      ) : 0;
      x2 = clientWidth + scrollLeft;
    } else {
      _scrollSpeed.x = 0;
    }
    if (_areaClientLocation.y2 + this._scrollDelta.y < _containerRect.top + startScrollMargins.y) {
      _scrollSpeed.y = scrollTop ? -abs(
        _containerRect.top - _areaClientLocation.y2 - this._scrollDelta.y
      ) : 0;
      y2 = max(y2, this._container.scrollTop);
    } else if (_areaClientLocation.y2 + this._scrollDelta.y > _containerRect.bottom - startScrollMargins.y) {
      _scrollSpeed.y = scrollHeight - scrollTop - clientHeight ? abs(
        _containerRect.top + this._container.clientHeight - _areaClientLocation.y2 - this._scrollDelta.y
      ) : 0;
      y2 = clientHeight + scrollTop;
    } else {
      _scrollSpeed.y = 0;
    }
    const x3 = min(x1, x2);
    const y3 = min(y1, y2);
    const x4 = max(x1, x2);
    const y4 = max(y1, y2);
    _areaRect.x = x3;
    _areaRect.y = y3;
    _areaRect.width = x4 - x3;
    _areaRect.height = y4 - y3;
  }
  _redrawSelectionArea() {
    const { height, width, x, y } = this._areaRect;
    const { style } = this._area;
    style.left = `${x}px`;
    style.top = `${y}px`;
    style.width = `${width}px`;
    style.height = `${height}px`;
  }
  _setupSelectionArea() {
  }
  _updateElementSelection() {
    const { _areaRect, _options, _selectables, _selection } = this;
    const { selected, stored, touched } = _selection;
    const { intersect, overlap } = _options.behaviour;
    const invert = overlap === "invert";
    const newlyTouched = [];
    const added = [];
    const removed = [];
    for (let i = 0; i < _selectables.length; i++) {
      const node = _selectables[i];
      if (intersectsScroll(
        _areaRect,
        node.getBoundingClientRect(),
        intersect,
        this._container
      )) {
        if (!selected.includes(node)) {
          if (invert && stored.includes(node)) {
            removed.push(node);
            continue;
          } else {
            added.push(node);
          }
        } else if (stored.includes(node) && !touched.includes(node)) {
          touched.push(node);
        }
        newlyTouched.push(node);
      }
    }
    if (invert) {
      added.push(...stored.filter((v) => !selected.includes(v)));
    }
    const keep = overlap === "keep";
    for (let i = 0; i < selected.length; i++) {
      const node = selected[i];
      if (!newlyTouched.includes(node) && !// Check if user wants to keep previously selected elements, e.g.
      // not make them part of the current selection as soon as they're touched.
      (keep && stored.includes(node))) {
        removed.push(node);
      }
    }
    _selection.selected = newlyTouched;
    _selection.changed = { added, removed };
    this._latestElement = void 0;
  }
  /**
   * Cancel the current selection process.
   *
   * @param keepEvent {boolean} true to fire a stop event after cancel.
   */
  cancel(keepEvent = false) {
    this._onTapStop(null, !keepEvent);
  }
  /**
   * Same as deselect, but for all elements currently selected.
   *
   * @param includeStored If the store should also get cleared
   * @param quiet If move / stop events should be fired
   */
  clearSelection(includeStored = true, quiet = false) {
    const { changed, selected, stored } = this._selection;
    changed.added = [];
    changed.removed.push(...selected, ...includeStored ? stored : []);
    if (!quiet) {
      this._emitEvent("move", null);
      this._emitEvent("stop", null);
    }
    this._selection = {
      changed: { added: [], removed: [] },
      selected: [],
      stored: includeStored ? [] : stored,
      touched: []
    };
  }
  /**
   * Removes a particular element from the selection.
   *
   * @param query - CSS Query, can be an array of queries
   * @param quiet - If this should not trigger the move event
   */
  deselect(query, quiet = false) {
    const { changed, selected, stored } = this._selection;
    const elements = selectAll(query, this._options.document).filter(
      (el) => selected.includes(el) || stored.includes(el)
    );
    if (elements.length === 0) {
      return;
    }
    this._selection.stored = stored.filter((el) => !elements.includes(el));
    this._selection.selected = selected.filter((el) => !elements.includes(el));
    this._selection.changed.added = [];
    this._selection.changed.removed.push(
      ...elements.filter((el) => !changed.removed.includes(el))
    );
    this._latestElement = void 0;
    if (!quiet) {
      this._emitEvent("move", null);
      this._emitEvent("stop", null);
    }
  }
  /** Unbinds all events and removes the area-element. */
  destroy() {
    this.cancel();
    this.disable();
    super.unbindAllListeners();
  }
  /** @returns {Array} Selected elements */
  getSelection() {
    return this._selection.stored;
  }
  /** @returns {HTMLElement} The selection area element */
  getSelectionArea() {
    return this._area;
  }
  /**
   * Can be used if during a selection elements have been added. Will update
   * everything which can be selected.
   */
  resolveSelectables() {
    this._selectables = selectAll(
      this._options.selectables,
      this._options.document
    );
  }
  /**
   * Adds elements to the selection
   *
   * @param query - CSS Query, can be an array of queries
   * @param quiet - If this should not trigger the move event
   */
  select(query, quiet = false) {
    const { changed, selected, stored } = this._selection;
    const elements = selectAll(query, this._options.document).filter(
      (el) => !selected.includes(el) && !stored.includes(el)
    );
    stored.push(...elements);
    selected.push(...elements);
    changed.added.push(...elements);
    changed.removed = [];
    this._latestElement = void 0;
    if (!quiet) {
      this._emitEvent("move", null);
      this._emitEvent("stop", null);
    }
    return elements;
  }
  /**
   * Manually triggers the start of a selection
   *
   * @param evt A MouseEvent / TouchEvent -like object
   * @param silent If beforestart should be fired,
   */
  trigger(evt, silent = true) {
    this._onTapStart(evt, silent);
  }
};

// src/react/useSelectionArea.ts
var useSelectionArea = () => {
  const { api, editor, getOptions, setOption } = useEditorPlugin(BlockSelectionPlugin);
  const { areaOptions } = getOptions();
  React.useEffect(() => {
    const selection = new SelectionArea(__spreadValues({
      document: window.document
    }, areaOptions)).on("start", ({ event }) => {
      setOption("isSelectionAreaVisible", true);
      deselectEditor(editor);
      if (!(event == null ? void 0 : event.shiftKey)) {
        selection.clearSelection();
        api.blockSelection.resetSelectedIds();
      }
    }).on("move", ({ store: { changed } }) => {
      if (!getOptions().isSelectionAreaVisible) {
        setOption("isSelectionAreaVisible", true);
      }
      if (changed.added.length === 0 && changed.removed.length === 0) return;
      api.blockSelection.setSelectedIds(changed);
    }).on("stop", () => {
      setOption("isSelectionAreaVisible", false);
    });
    return () => selection.destroy();
  }, []);
};

// src/react/utils/copySelectedBlocks.ts
import {
  deselect,
  getEditorPlugin,
  getEndPoint,
  getStartPoint,
  select,
  withoutNormalizing
} from "@udecode/plate-common";
import copyToClipboard from "copy-to-clipboard";
var copySelectedBlocks = (editor) => {
  const { api, getOptions, setOption } = getEditorPlugin(
    editor,
    BlockSelectionPlugin
  );
  const { selectedIds } = getOptions();
  const selectedEntries = api.blockSelection.getSelectedBlocks();
  const selectedFragment = selectedEntries.map(([node]) => node);
  copyToClipboard(" ", {
    onCopy: (dataTransfer) => {
      const data = dataTransfer;
      if (!data) return;
      let textPlain = "";
      const div = document.createElement("div");
      withoutNormalizing(editor, () => {
        selectedEntries.forEach(([, path]) => {
          select(editor, {
            anchor: getStartPoint(editor, path),
            focus: getEndPoint(editor, path)
          });
          editor.setFragmentData(data);
          textPlain += `${data.getData("text/plain")}
`;
          const divChild = document.createElement("div");
          divChild.innerHTML = data.getData("text/html");
          div.append(divChild);
        });
        deselect(editor);
        setOption("selectedIds", selectedIds);
      });
      data.setData("text/plain", textPlain);
      data.setData("text/html", div.innerHTML);
      const selectedFragmentStr = JSON.stringify(selectedFragment);
      const encodedFragment = window.btoa(
        encodeURIComponent(selectedFragmentStr)
      );
      data.setData("application/x-slate-fragment", encodedFragment);
    }
  });
};

// src/react/utils/onChangeBlockSelection.ts
import { getEditorPlugin as getEditorPlugin2 } from "@udecode/plate-common";
var onChangeBlockSelection = ({
  api,
  editor,
  getOptions
}) => {
  const blockContextMenu = getEditorPlugin2(editor, BlockContextMenuPlugin);
  if (editor.selection && getOptions().isSelecting && !blockContextMenu.getOption("isOpen", editor.id)) {
    api.blockSelection.unselect();
    blockContextMenu.api.blockContextMenu.hide();
  }
};

// src/react/utils/openContextMenu.ts
import {
  collapseSelection,
  getAncestorNode,
  getEditorPlugin as getEditorPlugin3
} from "@udecode/plate-common";
var openContextMenu = (editor, e, selectedId) => {
  var _a;
  const { api } = getEditorPlugin3(editor, BlockSelectionPlugin);
  const blockContextMenu = getEditorPlugin3(editor, BlockContextMenuPlugin);
  const id = selectedId != null ? selectedId : (_a = getAncestorNode(editor)) == null ? void 0 : _a[0].id;
  if (!id) return;
  api.blockSelection.addSelectedRow(id);
  blockContextMenu.api.blockContextMenu.show(editor.id, e);
  collapseSelection(editor);
  return true;
};

// src/react/utils/pasteSelectedBlocks.ts
import {
  deselect as deselect2,
  getEditorPlugin as getEditorPlugin5,
  getStartPoint as getStartPoint2,
  insertNodes,
  isElementEmpty
} from "@udecode/plate-common";
import { focusEditor, insertData } from "@udecode/plate-common/react";
import { Path } from "slate";

// src/react/utils/selectInsertedBlocks.ts
import {
  getEditorPlugin as getEditorPlugin4,
  isBlock
} from "@udecode/plate-common";
var selectInsertedBlocks = (editor) => {
  const { setOption } = getEditorPlugin4(editor, BlockSelectionPlugin);
  const ids = /* @__PURE__ */ new Set();
  editor.operations.forEach((op) => {
    if (op.type === "insert_node" && op.node.id && isBlock(editor, op.node)) {
      ids.add(op.node.id);
    }
  });
  setTimeout(() => {
    setOption("isSelecting", true);
    setOption("selectedIds", ids);
  }, 0);
};

// src/react/utils/pasteSelectedBlocks.ts
var pasteSelectedBlocks = (editor, e) => {
  const { api } = getEditorPlugin5(editor, BlockSelectionPlugin);
  const entries = api.blockSelection.getSelectedBlocks();
  if (entries.length > 0) {
    const entry = entries.at(-1);
    const [node, path] = entry;
    focusEditor(editor, getStartPoint2(editor, path));
    if (!isElementEmpty(editor, node)) {
      const at = Path.next(path);
      insertNodes(editor, editor.api.create.block({}, at), {
        at,
        select: true
      });
    }
    insertData(editor, e.clipboardData);
    deselect2(editor);
    selectInsertedBlocks(editor);
  }
};

// src/react/BlockSelectionAfterEditable.tsx
var BlockSelectionAfterEditable = () => {
  const editor = useEditorRef();
  const { api, getOption, getOptions, useOption } = useEditorPlugin2(BlockSelectionPlugin);
  const isSelecting = useOption("isSelecting");
  const selectedIds = useOption("selectedIds");
  const blockContextMenu = useEditorPlugin2(BlockContextMenuPlugin);
  const isOpen = blockContextMenu.useOption("isOpen", editor.id);
  useSelectionArea();
  const inputRef = React2.useRef(null);
  const [isMounted, setIsMounted] = React2.useState(false);
  React2.useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  React2.useEffect(() => {
    if (isSelecting && !isOpen && inputRef.current) {
      inputRef.current.focus();
    } else if (inputRef.current) {
      inputRef.current.blur();
    }
  }, [isSelecting, isOpen]);
  const handleKeyDown = React2.useCallback(
    (e) => {
      var _a, _b;
      const isReadonly = isEditorReadOnly(editor);
      (_b = (_a = getOptions()).onKeyDownSelecting) == null ? void 0 : _b.call(_a, e.nativeEvent);
      if (!getOptions().isSelecting) return;
      if (isHotkey("escape")(e)) {
        api.blockSelection.unselect();
      }
      if (isHotkey("mod+z")(e)) {
        editor.undo();
        selectInsertedBlocks(editor);
      }
      if (isHotkey("mod+shift+z")(e)) {
        editor.redo();
        selectInsertedBlocks(editor);
      }
      if (!getOption("isSelectingSome")) return;
      if (isHotkey("enter")(e)) {
        const entry = findNode(editor, {
          at: [],
          match: (n) => selectedIds.has(n.id)
        });
        if (entry) {
          const [, path] = entry;
          focusEditor2(editor, getEndPoint2(editor, path));
          e.preventDefault();
        }
      }
      if (isHotkey(["backspace", "delete"])(e) && !isReadonly) {
        removeNodes(editor, {
          at: [],
          match: (n) => selectedIds.has(n.id)
        });
      }
      if (isHotkey("up")(e)) {
        const firstId = [...selectedIds][0];
        const node = findNode(editor, {
          at: [],
          match: (n) => n.id === firstId
        });
        const prev = getPreviousNode(editor, {
          at: node == null ? void 0 : node[1]
        });
        const prevId = prev == null ? void 0 : prev[0].id;
        api.blockSelection.addSelectedRow(prevId);
      }
      if (isHotkey("down")(e)) {
        const lastId = [...selectedIds].pop();
        const node = findNode(editor, {
          at: [],
          match: (n) => n.id === lastId
        });
        const next = getNextNode(editor, {
          at: node == null ? void 0 : node[1]
        });
        const nextId = next == null ? void 0 : next[0].id;
        api.blockSelection.addSelectedRow(nextId);
      }
    },
    [editor, selectedIds, api, getOptions, getOption]
  );
  const handleCopy = React2.useCallback(
    (e) => {
      e.preventDefault();
      if (getOption("isSelectingSome")) {
        copySelectedBlocks(editor);
      }
    },
    [editor, getOption]
  );
  const handleCut = React2.useCallback(
    (e) => {
      e.preventDefault();
      if (getOption("isSelectingSome")) {
        copySelectedBlocks(editor);
        if (!isEditorReadOnly(editor)) {
          removeNodes(editor, {
            at: [],
            match: (n) => selectedIds.has(n.id)
          });
          focusEditor2(editor);
        }
      }
    },
    [editor, selectedIds, getOption]
  );
  const handlePaste = React2.useCallback(
    (e) => {
      e.preventDefault();
      if (!isEditorReadOnly(editor)) {
        pasteSelectedBlocks(editor, e.nativeEvent);
      }
    },
    [editor]
  );
  if (!isMounted || typeof window === "undefined") {
    return null;
  }
  return ReactDOM.createPortal(
    /* @__PURE__ */ React2.createElement(
      "input",
      {
        ref: inputRef,
        className: "slate-shadow-input",
        style: {
          left: "-300px",
          opacity: 0,
          position: "fixed",
          top: "-300px",
          zIndex: 999
        },
        onCopy: handleCopy,
        onCut: handleCut,
        onKeyDown: handleKeyDown,
        onPaste: handlePaste
      }
    ),
    document.body
  );
};

// src/react/components/BlockSelectable.tsx
import React3, { useRef } from "react";
import {
  getAboveNode,
  isInline,
  isVoid,
  queryNode
} from "@udecode/plate-common";
import {
  createAtomStore,
  findNodePath,
  useEditorPlugin as useEditorPlugin3
} from "@udecode/plate-common/react";
import { Path as Path2 } from "slate";
var { BlockSelectableProvider, useBlockSelectableStore } = createAtomStore(
  {
    selectable: false
  },
  { name: "blockSelectable" }
);
var useBlockSelectableState = ({
  active,
  element
}) => {
  const { editor, getOptions } = useEditorPlugin3(BlockSelectionPlugin);
  const ref = useRef(null);
  const path = React3.useMemo(
    () => findNodePath(editor, element),
    [editor, element]
  );
  if (!path || isInline(editor, element)) {
    return {
      active: active != null ? active : false
    };
  }
  const { query } = getOptions();
  if (query && !queryNode([element, path], query)) {
    return {
      active: active != null ? active : false
    };
  }
  return {
    active: active != null ? active : true,
    element,
    path,
    ref
  };
};
var useBlockSelectable = ({
  active,
  element,
  path,
  ref
}) => {
  const { api, editor, getOption, getOptions } = useEditorPlugin3(BlockSelectionPlugin);
  const id = element == null ? void 0 : element.id;
  const data = { "data-key": id };
  return {
    props: __spreadValues({
      className: "slate-selectable",
      ref,
      onContextMenu: (event) => {
        var _a, _b;
        if (!element || !active) return;
        const { enableContextMenu } = getOptions();
        if (!enableContextMenu) return;
        if ((_a = editor.selection) == null ? void 0 : _a.focus) {
          const nodeEntry = getAboveNode(editor);
          if (nodeEntry && Path2.isCommon(path, nodeEntry[1])) {
            const id2 = nodeEntry[0].id;
            const isSelected = getOption("isSelected", id2);
            const isOpenAlways = ((_b = event.target.dataset) == null ? void 0 : _b.openContextMenu) === "true";
            if (!isSelected && !isVoid(editor, nodeEntry[0]) && !isOpenAlways)
              return event.stopPropagation();
          }
        }
        const aboveHtmlNode = ref.current;
        if (id && aboveHtmlNode) {
          api.blockSelection.addSelectedRow(id, {
            aboveHtmlNode,
            clear: !(event == null ? void 0 : event.shiftKey)
          });
        }
      }
    }, data)
  };
};
function BlockSelectable(_a) {
  var _b = _a, {
    children,
    options
  } = _b, props = __objRest(_b, [
    "children",
    "options"
  ]);
  const state = useBlockSelectableState(options);
  const blockSelectable = useBlockSelectable(state);
  if (!state.active)
    return /* @__PURE__ */ React3.createElement(BlockSelectableProvider, null, children);
  return /* @__PURE__ */ React3.createElement(BlockSelectableProvider, { selectable: true }, /* @__PURE__ */ React3.createElement("div", __spreadValues(__spreadValues({}, blockSelectable.props), props), children));
}

// src/react/onKeyDownSelection.ts
import {
  getAncestorNode as getAncestorNode2,
  isHotkey as isHotkey2,
  isRangeInSameBlock,
  isSelectionCoverBlock,
  select as select2
} from "@udecode/plate-common";
var onKeyDownSelection = ({
  api,
  editor,
  event
}) => {
  if (isHotkey2("mod+a", event)) {
    if (event.defaultPrevented) return;
    const ancestorNode = getAncestorNode2(editor);
    if (!ancestorNode) return;
    const [, path] = ancestorNode;
    if (isSelectionCoverBlock(editor)) {
      return api.blockSelection.selectedAll();
    }
    if (!isRangeInSameBlock(editor)) {
      return api.blockSelection.selectedAll();
    }
    select2(editor, path);
    event.preventDefault();
    event.stopPropagation();
  }
  if (isHotkey2("escape", event)) {
    if (event.defaultPrevented) return;
    const ancestorNode = getAncestorNode2(editor);
    const id = ancestorNode == null ? void 0 : ancestorNode[0].id;
    api.blockSelection.addSelectedRow(id);
    event.preventDefault();
    event.stopPropagation();
  }
};

// src/react/BlockSelectionPlugin.tsx
var BlockSelectionPlugin = createTPlatePlugin2({
  key: "blockSelection",
  options: {
    areaOptions: {
      behaviour: {
        scrolling: {
          speedDivider: 5,
          startScrollMargins: { x: 20, y: 0 }
        },
        startThreshold: 5
      },
      features: {
        singleTap: {
          allow: false
        }
      }
    },
    enableContextMenu: false,
    isSelecting: false,
    isSelectionAreaVisible: false,
    query: {
      maxLevel: 1
    },
    selectedIds: /* @__PURE__ */ new Set()
  },
  plugins: [BlockContextMenuPlugin],
  render: {
    aboveNodes: () => ({ children, element }) => BlockSelectable({
      children,
      options: {
        element
      }
    }),
    afterEditable: BlockSelectionAfterEditable
  },
  handlers: {
    onChange: onChangeBlockSelection,
    onKeyDown: onKeyDownSelection
  }
}).extendOptions(({ getOptions }) => ({
  isSelected: (id) => !!id && getOptions().selectedIds.has(id),
  isSelectingSome: () => getOptions().selectedIds.size > 0
})).extendApi(({ getOptions, setOption }) => ({
  resetSelectedIds: () => {
    setOption("selectedIds", /* @__PURE__ */ new Set());
  },
  setSelectedIds: ({ added, removed }) => {
    const { selectedIds: prev } = getOptions();
    const next = new Set(prev);
    extractSelectableIds(added).forEach((id) => next.add(id));
    extractSelectableIds(removed).forEach((id) => next.delete(id));
    setOption("selectedIds", next);
    setOption("isSelecting", true);
  },
  unselect: () => {
    setOption("selectedIds", /* @__PURE__ */ new Set());
    setOption("isSelecting", false);
  }
})).extendApi(
  ({ api, editor, getOption, getOptions, setOption }) => ({
    addSelectedRow: (id, options = {}) => {
      const { aboveHtmlNode, clear = true } = options;
      const element = aboveHtmlNode != null ? aboveHtmlNode : getSelectedDomNode(id);
      if (!element) return;
      if (!getOptions().selectedIds.has(id) && clear) {
        setOption("selectedIds", /* @__PURE__ */ new Set());
      }
      api.blockSelection.setSelectedIds({
        added: [element],
        removed: []
      });
    },
    getSelectedBlocks: () => {
      return [
        ...getNodeEntries(editor, {
          at: [],
          match: (n) => getOption("isSelected", n.id)
        })
      ];
    },
    selectedAll: () => {
      const all = getAllSelectableDomNode();
      setOption("selectedIds", /* @__PURE__ */ new Set());
      api.blockSelection.setSelectedIds({
        added: Array.from(all),
        removed: []
      });
    }
  })
);

// src/react/context-menu/types.ts
var ACTION_DELETE = "context_menu_delete";
var ACTION_COPY = "context_menu_copy";

// src/react/context-menu/useBlockContextMenu.ts
import { useMemo } from "react";
import { useEditorPlugin as useEditorPlugin4 } from "@udecode/plate-common/react";
var useBlockContextMenuState = () => {
  const { api, editor, useOption } = useEditorPlugin4(BlockSelectionPlugin);
  const blockContextMenu = useEditorPlugin4(BlockContextMenuPlugin);
  const isOpen = blockContextMenu.useOption("isOpen", editor.id);
  const selectedIds = useOption("selectedIds");
  const action = useMemo(() => blockContextMenu.getOptions().action, [isOpen]);
  const selectedBlocks = api.blockSelection.getSelectedBlocks();
  return {
    action,
    editor,
    isOpen,
    selectedBlocks,
    selectedIds
  };
};
var useBlockContextMenu = () => {
  return {
    props: {
      // onOpenChange: (value: boolean) => {
      //   if (value) {
      //     api.show(editor.id);
      //   } else {
      //     api.hide();
      //   }
      // },
    }
  };
};

// src/react/context-menu/useBlockMenuItems.ts
import { useEditorPlugin as useEditorPlugin5 } from "@udecode/plate-common/react";
var useBlockMenuItemsState = () => {
  const { api, editor, useOption } = useEditorPlugin5(BlockSelectionPlugin);
  const blockContextMenu = useEditorPlugin5(BlockContextMenuPlugin);
  const isOpen = blockContextMenu.useOption("isOpen", editor.id);
  const selectedIds = useOption("selectedIds");
  const selectedBlocks = api.blockSelection.getSelectedBlocks();
  return {
    isOpen,
    selectedBlocks,
    selectedIds
  };
};
var useBlockMenuItems = () => {
  return {};
};

// src/react/useBlockSelected.ts
import { useEditorPlugin as useEditorPlugin6, useElement } from "@udecode/plate-common/react";
var useBlockSelected = (_id) => {
  const { useOption } = useEditorPlugin6(BlockSelectionPlugin);
  const { id } = useElement();
  const isBlockSelected = useOption("isSelected", id);
  return isBlockSelected;
};
export {
  ACTION_COPY,
  ACTION_DELETE,
  BlockContextMenuPlugin,
  BlockSelectable,
  BlockSelectableProvider,
  BlockSelectionAfterEditable,
  BlockSelectionPlugin,
  copySelectedBlocks,
  onChangeBlockSelection,
  onKeyDownSelection,
  openContextMenu,
  pasteSelectedBlocks,
  selectInsertedBlocks,
  useBlockContextMenu,
  useBlockContextMenuState,
  useBlockMenuItems,
  useBlockMenuItemsState,
  useBlockSelectable,
  useBlockSelectableState,
  useBlockSelectableStore,
  useBlockSelected,
  useSelectionArea
};
//# sourceMappingURL=index.mjs.map